import React, { FC } from 'react';

import { TEXTS } from 'application/pages/BillingPage/renderer/texts';

import { PaymentMethodInfoTypeFragment } from '@shared/api/graphql/generated';

import Button, { ButtonType, ButtonSize } from '@zvuk-b2b/react-uikit/ui/Button';

import styles from './index.module.scss';

interface CardActionsProps {
  paymentMethod?: PaymentMethodInfoTypeFragment | null;
  isLinkingInProcess: boolean;
  cardActionsLoading: boolean;
  hasWaitPaymentLicenses: boolean;
  onBindCardClick: () => Promise<void>;
  onRebindCardClick: () => void;
  onRemoveCardClick: () => void;
}

const CardActions: FC<CardActionsProps> = ({
  paymentMethod,
  isLinkingInProcess,
  cardActionsLoading,
  hasWaitPaymentLicenses,
  onBindCardClick,
  onRebindCardClick,
  onRemoveCardClick,
}) => (
  <>
    {(paymentMethod || isLinkingInProcess || hasWaitPaymentLicenses) && (
      <div className={styles.cardActionsContainer}>
        <Button
          elementId="button_rebind_card_modal"
          className={styles.cardActionsButton}
          type={ButtonType.SECONDARY}
          isDisabled={hasWaitPaymentLicenses || cardActionsLoading || isLinkingInProcess}
          size={ButtonSize.SMALL}
          onClick={onRebindCardClick}>
          {hasWaitPaymentLicenses ? TEXTS.BILLING_WAIT_PAYMENT_BUTTON_TEXT : TEXTS.BILLING_REBIND_CARD_BUTTON_TEXT}
        </Button>

        {!hasWaitPaymentLicenses && (
          <Button
            elementId="button_remove_card_modal"
            type={ButtonType.DANGER}
            size={ButtonSize.SMALL}
            isDisabled={cardActionsLoading || isLinkingInProcess}
            onClick={onRemoveCardClick}
            className={styles.cardActionsButton}>
            {TEXTS.BILLING_REMOVE_CARD_BUTTON_TEXT}
          </Button>
        )}
      </div>
    )}

    {!paymentMethod && !isLinkingInProcess && !hasWaitPaymentLicenses && (
      <Button
        elementId="button_bind_card_modal"
        type={ButtonType.PRIMARY}
        size={ButtonSize.SMALL}
        onClick={onBindCardClick}
        className={styles.cardActionsButton}>
        {TEXTS.BILLING_BIND_CARD_BUTTON_TEXT}
      </Button>
    )}
  </>
);

export default React.memo(CardActions);
